/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import { connect, useDispatch } from 'react-redux';
import { setDashboardItemSelected } from 'store/actions/dashboard/setDashboardItemSelected';
import ApprovedAreas from 'components/approvedAreas/Main';
import Uavos from 'components/uavos/Main';
import Zones from 'components/zones/DashboardZones';
import OperationsApprovals from 'components/operationsApprovals/DashboardOperationsApprovals';
import MissionsApprovals from 'components/missionsApprovals/DashboardMissionsApprovals';
import { formStyles } from 'consts/styles/Form';
import { addAlert } from 'store/actions/alert/alerts';
import socketContext from 'components/contentWrapper/socketContext';
import { setDashboardSelectedMissionsApprovals } from 'store/actions/dashboard/selectedMissionsApprovals';
import { setDashboardSelectedOperationsApprovals } from 'store/actions/dashboard/selectedOperationsApprovals';
import { userStyles } from 'consts/styles/User';
// import EachSideAdminContentHandler from 'components/user/admin/users/EachSideAdminContentHandler';
import { getZonesFromUserSettings } from 'components/dashboard/utils/main';
import DashboardFiltersMenu from './filters/DashboardFiltersMenu';
import { useStyles, StyledBadge } from './DashboardMainUseStyles';

const TabPanel = props => {
  const { children, index, value } = props;
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={
        value === index
          ? `${classes.DashboardMain}__content`
          : `${classes.DashboardMain}__content--display-none`
      }
    >
      <Box>
        <Typography component="div">{children}</Typography>
      </Box>
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const TabSwitcherPanel = props => {
  const { children, index, value } = props;
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={
        value === index
          ? `${classes.DashboardMain}__switcher__content`
          : `${classes.DashboardMain}__switcher__content--display-none`
      }
    >
      <Box>
        <Typography component="div">{children}</Typography>
      </Box>
    </div>
  );
};

TabSwitcherPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = index => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-width-scroll-tabpanel-${index}`,
});

const DashboardMain = props => {
  const {
    selectedDashboardUavos,
    selectedZones,
    selectedApprovedAreas,
    isDashboardItemSelected,
    language,
    zonesCategories,
    currentOperationsApprovals,
    currentMissionsApprovals,
  } = props;

  const [zonesFilters, setZonesFilters] = React.useState([]);
  const [zonesCategoriesFilters, setZonesCategoriesFilters] = React.useState(
    zonesCategories.map(zone => zone.uid)
  );
  const [value, setValue] = React.useState(0);
  const [switcher, setSwitcher] = React.useState(0);

  const tabsAction = React.useRef();
  const selectTabsAction = React.useRef();
  const socket = React.useContext(socketContext);

  const dispatch = useDispatch();

  const classes = useStyles();
  const classesUser = userStyles();
  const formClasses = formStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeSwitcher = (event, newValue) => {
    setSwitcher(newValue);
  };

  const showDetailsPanel = () =>
    !!(
      selectedApprovedAreas.length ||
      selectedDashboardUavos.length ||
      selectedZones.length
    );

  React.useEffect(() => {
    const defaultZones = getZonesFromUserSettings();
    setZonesFilters(defaultZones);
  }, []);

  React.useEffect(() => {
    if (selectedApprovedAreas.length) setValue(2);
  }, [selectedApprovedAreas]);

  React.useEffect(() => {
    if (selectedZones.length) setValue(1);
  }, [selectedZones]);

  React.useEffect(() => {
    if (selectedDashboardUavos.length) setValue(0);
  }, [selectedDashboardUavos]);

  React.useEffect(() => {
    const result = showDetailsPanel();
    if (result) dispatch(setDashboardItemSelected(false));
  }, [showDetailsPanel(), isDashboardItemSelected]);

  const handleSocketUpdate = () => {
    if (!socket) return;
    socket.on('operations', socketOperations => {
      if (socketOperations === 'no data') return;
      dispatch(setDashboardSelectedOperationsApprovals(socketOperations));
    });

    socket.on('missions', socketMissions => {
      if (socketMissions === 'no data') return;
      dispatch(setDashboardSelectedMissionsApprovals(socketMissions));
    });

    socket.on('disconnect', () => {
      dispatch(
        addAlert({
          title: language.alerts.requestError.title_,
          desc: language.alerts.requestError.desc_,
          type: 'error',
        })
      );
    });

    return () => {
      socket.off('operations');
      socket.off('missions');
    };
  };

  React.useEffect(handleSocketUpdate, [socket]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      tabsAction.current.updateIndicator();
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [switcher]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      selectTabsAction.current.updateIndicator();
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [value]);

  return (
    <div className={classes.DashboardMain}>
      <div
        value={switcher.toString()}
        className={`${classes.DashboardMain}__switcher ${classes.DashboardMain}__dashboard `}
      >
        <Box >
          <Tabs
            className={`${formClasses.Form}__tabs ${formClasses.Form}__tabs--background-color`}
            value={switcher}
            onChange={handleChangeSwitcher}
            aria-label="simple tabs example"
            indicatorColor="primary"
            variant="fullWidth"
            centered
            classes={{
              root: `${formClasses.Form}__text-field`,
              indicator: `${formClasses.Form}__tabs__button ${formClasses.Form}__tabs__button--width`,
            }}
            action={tabsAction}
          >
            <Tab
              label={
                <StyledBadge
                  badgeContent={currentOperationsApprovals.length}
                  classes={{
                    badge: `${formClasses.Form}__tabs__button ${formClasses.Form}__text-field--black`,
                  }}
                >
                  {language?.sidebar?.uspace.operations_}
                </StyledBadge>
              }
              {...a11yProps(0)}
            />
            <Tab
              label={
                <StyledBadge
                  classes={{
                    badge: `${formClasses.Form}__tabs__button ${formClasses.Form}__text-field--black`,
                  }}
                  badgeContent={currentMissionsApprovals.length}
                >
                  {language?.sidebar?.uspace.missions_}
                </StyledBadge>
              }
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
        <TabSwitcherPanel value={switcher} index={0}>
          <OperationsApprovals
            currentOperationsApprovals={currentOperationsApprovals}
          />
        </TabSwitcherPanel>
        <TabSwitcherPanel value={switcher} index={1}>
          <MissionsApprovals
            currentMissionsApprovals={currentMissionsApprovals}
          />
        </TabSwitcherPanel>
      </div>
      <div className={`${classes.DashboardMain}__filters`}>
        <DashboardFiltersMenu
          setZonesFilters={setZonesFilters}
          setFiltersOption={setValue}
          setZonesCategoriesFilters={setZonesCategoriesFilters}
          zonesCategoriesFilters={zonesCategoriesFilters}
          zonesFilters={zonesFilters}
        />
      </div>
      <div
        value={value.toString()}
        className={clsx(
          `${classesUser.User} ${classesUser.User}__dashboard ${classesUser.User}__dashboard__selected ${formClasses.Form}--flex ${formClasses.Form}--flex--direction`,
          {
            [`${classesUser.User}__dashboard__selected--display-none`]:
              !showDetailsPanel() || isDashboardItemSelected,
          }
        )}
      >
        <Box>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            aria-label="scrollable force tabs example"
            centered
            classes={{
              root: `${formClasses.Form}__text-field ${formClasses.Form}--width`,
              indicator: `${formClasses.Form}__tabs__button`,
            }}
            action={selectTabsAction}
          >
            <Tab
              label={language.operationsDetails.selectedUavosHeader_}
              {...a11yProps(0)}
            />

            <Tab
              label={language.zonesDetails.zonesListHeader_}
              {...a11yProps(1)}
            />

            <Tab
              label={language.approvedAreasDetails.approvedAreasDetails_}
              {...a11yProps(2)}
            />
          </Tabs>
        </Box>

        <TabPanel value={value} index={0}>
          <Uavos />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Zones
            zonesTypesToDisplay={zonesFilters}
            zonesCategoriesToDisplay={zonesCategoriesFilters}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ApprovedAreas />
        </TabPanel>
      </div>
    </div>
  );
};

DashboardMain.propTypes = {
  selectedDashboardUavos: PropTypes.array.isRequired,
  selectedZones: PropTypes.array.isRequired,
  selectedApprovedAreas: PropTypes.array.isRequired,
  isDashboardItemSelected: PropTypes.bool,
  zonesCategories: PropTypes.array.isRequired,
  language: PropTypes.object.isRequired,
  currentOperationsApprovals: PropTypes.array.isRequired,
  currentMissionsApprovals: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  selectedDashboardUavos: state.selectedDashboardUavos,
  selectedZones: state.selectedZones,
  selectedApprovedAreas: state.selectedApprovedAreas,
  isDashboardItemSelected: state.isDashboardItemSelected,
  zonesCategories: state.zonesCategories,
  language: state.language,
  currentOperationsApprovals: state.selectedDashboardOperationsApprovals,
  currentMissionsApprovals: state.selectedDashboardMissionsApprovals,
});

export default connect(mapStateToProps)(React.memo(DashboardMain));
